import { TextColor } from '@/shared/types/text';

// Lista de colores del sistema para validación
export const SYSTEM_COLORS: TextColor[] = [
  'primary',
  'secondary',
  'tertiary',
  'disabled',
  'on-color',
  'on-canvas-inverse',
  'brand',
  'brand-hover',
  'brand-pressed',
  'brand-selected',
  'success',
  'success-hover',
  'success-pressed',
  'success-selected',
  'warning',
  'warning-hover',
  'warning-pressed',
  'warning-selected',
  'danger',
  'danger-hover',
  'danger-pressed',
  'danger-selected',
  'info',
  'info-hover',
  'info-pressed',
  'info-selected',
  'link',
  'link-hover',
  'link-pressed',
  'link-visited',
  'all-colors-red',
  'all-colors-orange',
  'all-colors-yellow',
  'all-colors-lime',
  'all-colors-green',
  'all-colors-cyan',
  'all-colors-azure',
  'all-colors-blue',
  'all-colors-violet',
  'all-colors-magenta',
  'all-colors-rose',
];
